import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  /** ローディング状態 */
  private loading$ = new BehaviorSubject<boolean>(true);

  /** ローディング状態の数 */
  private loadingIndex = 0;

  /**
   * ローディング状態を取得する
   */
  get loading() {
    return this.loading$;
  }

  /** ローディングを表示する */
  public show(): void {
    this.loadingIndex++;
    setTimeout(() => this.loading$.next(true));
  }

  /** ローディングを非表示にする */
  public hide(): void {
    this.loadingIndex--;
    if (this.loadingIndex < 1) {
      // 負の値になり表示できなくなるのを防ぐために初期化
      this.clear();
    }
  }

  /** ローディングをクリアにする */
  public clear(): void {
    this.loadingIndex = 0;
    setTimeout(() => this.loading$.next(false));
  }

  /**
   * 非同期操作のラッパー関数
   * @param asyncOperation 非同期操作
   * @param withLoading ローディング表示をするか(true:表示, false:非表示)
   */
  asyncWrapper<T>(
    asyncOperation: Promise<T> | Observable<T>,
    withLoading: boolean = true
  ): Observable<T> {
    if (withLoading) {
      this.show();
    }
    return from(asyncOperation).pipe(
      finalize(() => {
        if (withLoading) {
          this.hide();
        }
      })
    );
  }
}
